import { useState, useEffect } from "react";
import axios from "axios";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import { ClockCounterClockwise, Spinner, User } from "@phosphor-icons/react";
import { toast } from "sonner";
import { useTranslation } from "react-i18next";

const API_URL = process.env.REACT_APP_BACKEND_URL;

const AdminActivityPage = () => {
  const { t } = useTranslation();
  const actionLabels = {
    low_balance_check: t("activity.low_balance_check"),
    invoice_generated: t("activity.invoice_generated"),
    invoice_paid: t("activity.invoice_paid"),
    customer_status_change: t("activity.customer_status_change"),
  };
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLogs = async () => {
      try {
        const res = await axios.get(`${API_URL}/api/admin/activity-logs`);
        setLogs(res.data);
      } catch (error) {
        toast.error(t("activity.logs_error"));
      } finally {
        setLoading(false);
      }
    };
    fetchLogs();
  }, []);

  if (loading) {
    return <div className="flex items-center justify-center h-64"><Spinner size={32} className="animate-spin text-indigo-600" /></div>;
  }

  return (
    <div className="space-y-6" data-testid="admin-activity-page">
      <div>
        <h1 className="text-2xl font-heading font-bold text-slate-900">{t("activity.title")}</h1>
        <p className="text-slate-500 mt-1">{t("activity.subtitle")}</p>
      </div>

      <Card className="border-slate-200 shadow-sm">
        <CardContent className="p-0">
          {logs.length === 0 ? (
            <div className="text-center py-12">
              <ClockCounterClockwise size={48} className="mx-auto text-slate-300 mb-4" />
              <p className="text-slate-500">{t("activity.no_logs")}</p>
            </div>
          ) : (
            <div className="divide-y divide-slate-100">
              {logs.map((log) => (
                <div key={log.id} className="flex items-start gap-4 p-4 hover:bg-slate-50" data-testid={`log-${log.id}`}>
                  <div className="w-10 h-10 bg-indigo-50 rounded-xl flex items-center justify-center flex-shrink-0 mt-0.5">
                    <User size={18} className="text-indigo-600" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 flex-wrap">
                      <span className="font-medium text-slate-900">{log.user_name || t("staff.system")}</span>
                      <Badge variant="outline" className="text-xs">{log.role}</Badge>
                      <span className="text-slate-400">-</span>
                      <span className="text-sm text-slate-700">{actionLabels[log.action] || log.action}</span>
                    </div>
                    {log.detail && <p className="text-sm text-slate-500 mt-0.5">{log.detail}</p>}
                    <p className="text-xs text-slate-400 mt-1">{new Date(log.created_at).toLocaleString("tr-TR")}</p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminActivityPage;
